module.exports = __webpack_public_path__ + "media/images/emblems/Concise-coat_of_arms-fc5b330d981ba7d00a14918fc87d70ee.svg";